export const sharePdf = async (): Promise<void> => {}
